import { render, staticRenderFns } from "./ActionPostbackTemplate.vue?vue&type=template&id=fafd76e8&scoped=true&"
import script from "./ActionPostbackTemplate.vue?vue&type=script&lang=js&"
export * from "./ActionPostbackTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ActionPostbackTemplate.vue?vue&type=style&index=0&id=fafd76e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafd76e8",
  null
  
)

export default component.exports